module.exports = __webpack_public_path__ + "static/media/support-grey.43a7b106.svg";